<template>
    <v-container>
      <v-row>
        <v-col>
          <div class="font-weight-bold mt-10 title-page" tabindex="0">Habilitações e Divergências</div>
        </v-col>
      </v-row>
  
      <br />
  
      <div class="mt-4" v-if="dataset.loading">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>
  
      <div v-if="!dataset.loading" v-html="!user ? dataset.contentUserAnonymous : dataset.contentUserLogged" tabindex="0">
      </div>
  
      <!-- <v-row v-if="!user" no-gutters>
        <v-col>
          <br>
          <iframe width="600" aria-label="Video de demonstração de como proceder" alt="" aria-hidden="true"
            arial-label="Video demonstrativo para criar uma habilitação ou divergência" height="500"
            src="https://www.youtube.com/embed/6okzXsdt0k0" frameborder="0" allowfullscreen></iframe>
        </v-col>
      </v-row> -->
  
      <br>
      <v-divider></v-divider>
      <br>
  
      <div v-if="user">
        <!-- <v-row>
          <v-col cols="12">
            <span class="mr-3"> <strong>Selecione a empresa a qual você gostaria de verificar se está incluído na lista de credores</strong></span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
  <span>Selecione a empresa a qual gostaria de habilitar ou divergir de um crédito</span>
  </v-tooltip>
  </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" class="mt-n3">
      <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.clients" label="Devedora"
        v-model="dataset.data.client" item-value="id" item-text="name" @change="onClientChange" outlined
        hide-details="auto" no-data-text="Nenhuma devedora encontrada">
      </v-autocomplete>
    </v-col>
  </v-row> -->
        <template v-if="isTimely">
          <v-row>
            <v-col>
              <div class="red--text">
                <span>
                  <strong>ATENÇÃO:</strong> A Administração Judicial considerou seu pedido
                  tempestivo em razão das dificuldades técnicas enfrentadas, apesar de enviado
                  após o prazo legal (03/12 às 23h59). A resposta ao seu pedido será entregue no
                  prazo do Edital do art. 7º, § 2º, da Lei 11.101/2005 - isto é, até
                  <strong>03 de março de 2025</strong>.
                </span>
              </div>
            </v-col>
          </v-row>
        </template>
  
        <template v-if="!isTimely && showLateWarning">
          <v-row>
            <v-col>
              <div class="red--text">
                <span>
                  <strong>ATENÇÃO:</strong> Seu pedido foi enviado após o prazo legal para recebimento das habilitações
                  e divergências de crédito (03/12 às 23h59). Assim, a Administração Judicial recebeu a solicitação
                  abaixo,
                  mas a sua análise dependerá de determinação do Juízo da Recuperação Judicial. Traremos novas informações
                  sobre isso nesta página, tão logo exista definição no processo. Caso você possua justificativa técnica
                  para o atraso, por favor, nos procure através da Central Nacional de Atendimento para analisarmos a sua
                  solicitação.
                </span>
              </div>
            </v-col>
          </v-row>
        </template>
  
  
  
  
        <!-- <v-row v-if="!this.loadingStatus">
          <v-col>
            <span v-if="this.dataset.data.release_status === 1">
              Atualmente, você não está incluído na lista. Você apresentou o pedido de alteração da lista abaixo:
            </span>
            <span v-else>
              Atualmente, você está incluído na lista pelo valor <strong>{{ (dataset.userRequestedValue || 0) | currency
                }}</strong>. Você apresentou o pedido de alteração da lista abaixo:
            </span>
          </v-col>
        </v-row> -->
  
        <v-row v-if="!this.loadingStatus && data.length">
          <v-col>
            <span v-if="!dataset.isAssociationCreditor">
              Atualmente, você não está incluído na lista. Você apresentou o pedido de alteração da lista abaixo:
            </span>
            <span v-else>
              Atualmente, você está incluído na lista pelo valor <strong>{{ (dataset.userRequestedValue || 0) | currency
                }}</strong>. Você apresentou o pedido de alteração da lista abaixo:
            </span>
          </v-col>
        </v-row>
  
        <!-- <v-row v-if="
          !dataset.loading && !data.length &&
          (!user.creditorData ||
            !user.creditorData.approved_amount_at ||
            user.creditorData.approved_amount_at === '0000-00-00 00:00:00')
        " class="mt-4">
          <v-col v-if="dataset.isAssociationCreditor">
            <p tabindex="0">
              <span v-if="
                (user.creditorData &&
                  (user.creditorData.approved_amount_at === '0000-00-00 00:00:00' ||
                    !user.creditorData.approved_amount_at)) &&
                !data.length
              ">
                <v-icon slot="icon" color="warning" size="36">
                  mdi-alert-outline
                </v-icon>
                <span tabindex="0">Você já está incluído na lista de credores com o valor de</span>
                {{ (dataset.userRequestedValue || 0) | currency }}.
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span tabindex="0">Clique no link abaixo para Concordar ou Dicordar deste valor.</span>
                </v-tooltip>
              </span>
  
              <br />
              <br />
              <span v-if="
                (!user.creditorData || !user.creditorData.approved_amount_at ||
                  user.creditorData.approved_amount_at === '0000-00-00 00:00:00') &&
                !data.length
              ">
                <a href="/#/habilitacoes-divergencias/novo"
                  aria-label="Link para concordar ou discordar do valor apresentado"><strong>Clique aqui</strong></a>
                para <strong>Concordar</strong> ou <strong>Discordar</strong> do valor apresentado.
              </span>
            </p>
          </v-col>
          <v-col v-else>
            <p tabindex="0">
              <v-icon color="warning">mdi-clock-time-two-outline</v-icon> Você não está incluído na
              lista de credores.
              <span v-if="!data.length">Caso queira se habilitar,
                <a href="/#/habilitacoes-divergencias/novo"><strong>clique aqui</strong></a></span>
            </p>
          </v-col>
        </v-row> -->
  
        <!-- <v-row v-if="user.requested_value"> -->
        <v-row v-if="user.creditorData && user.creditorData.approved_amount_at">
          <v-col v-if="
            user.creditorData.approved_amount_at &&
            user.creditorData.approved_amount_at !== '0000-00-00 00:00:00'
          ">
            <p tabindex="0">
              <v-icon color="accent">mdi-currency-usd</v-icon> Você concordou com o valor de
              {{ user.creditorData.approved_amount | currency }} no dia
              {{ user.creditorData.approved_amount_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" id="btnDiscord" type="button" elevation="0" color="#FFAB40"
                    class="ml-10" small dark @click="onDisagree()" tabindex="0"
                    aria-label="Botão para revogar aprovação de credito">
                    <v-icon left>mdi-restore</v-icon>
                    Revogar Aprovação
                  </v-btn>
                </template>
                <span>Desfazer concordância do valor</span>
              </v-tooltip> -->
            </p>
          </v-col>
        </v-row>
  
        <template v-if="processes.length > 0">
          <v-row v-for="(process, processIndex) in processes" :key="process.id">
            <v-col cols="12" class="mb-n3">
              <strong>Processo #{{ processIndex + 1 }}</strong>
            </v-col>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header class="custom-panel-header">
                    <p><strong>Número:</strong> {{ process.number }}</p>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p><strong>Local:</strong> {{ process.local }}</p>
                    <p><strong>Tribunal:</strong> {{ process.court }}</p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </template>
  
        <br />
        <template v-if="data.length">
          <div v-if="data[0].status == 4 || requestedDocOutOfDate">
            <v-alert dark color="#FF6F00" icon="mdi-alert-outline">
              <template v-if="!requestedDocOutOfDate">
                Há uma solicitação de novos documentos! Atenção: O prazo limite para envio dos documentos é até o
                {{ requestedDocDeadline }}.
              </template>
              <template v-else>
                Houve uma solicitação de novos documentos! Atenção: O prazo limite para envio dos documentos finalizou
                {{ requestedDocDeadline }}.
              </template>
              <br>
              <v-btn v-if="!requestedDocOutOfDate" type="button" elevation="0" color="#FFAB40" outlined
                class="button-with-border" small dark @click="loadRequestedDocuments()">
                Documentos
              </v-btn>
            </v-alert>
          </div>
          <div v-for="(item, i) in data" :key="i">
            <v-row>
              <v-col>
                <strong>Habilitação/Divergência #{{ i + 1 }}</strong>
                <br />
                <strong>Solicitado em: </strong>
                <span>{{ $moment(item.created_at).utc().format('DD/MM/YYYY') }}</span>
              </v-col>
  
              <v-col>
                <v-row align="center" justify="end" class="mr-1">
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                         <v-btn v-if="data && Array.isArray(data) && data.length > 0 && (data[0].reason || data[0].small_reason)" 
                            v-bind="attrs" v-on="on"  type="button" elevation="0"
                          tabindex="0" aria-label="Botão para visualizar as análises do status do pedido"
                          color="primary" outlined style="height: 30px;" dark @click="viewReason(item)">
                          <v-icon left>mdi-text-long </v-icon>
                          Análise
                        </v-btn>
                      </template>
                      <span>Visualizar Análise da Administração Judicial</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" v-if="item.status === 0" id="btnEdit" type="button" elevation="0"
                          tabindex="0" aria-label="Botão para editar os dados de uma habilitação ou divergência"
                          color="primary" style="height: 30px;" dark @click="editItem(item)">
                          <v-icon left>mdi-pencil</v-icon>
                          Editar
                        </v-btn>
                      </template>
                      <span>Editar informações desta habilitação / divergência</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" v-if="item.status === 0" id="btnDelete" type="button"
                          elevation="0" tabindex="0" aria-label="Botão para remover uma habilitação ou divergência"
                          color="important" style="height: 30px;" dark @click="openDeleteDialog(item)">
                          <v-icon left>mdi-trash-can</v-icon>
                          Remover
                        </v-btn>
                      </template>
                      <span>Remover esta habilitação / divergência</span>
                    </v-tooltip>
                  </v-col>
  
                  <v-col cols="auto">
                    <v-alert :color="getColorByStatus(item.status)" text-color="white"
                      shaped dense dark class="mt-4" style="max-width: 200px; height: 35px;">
                      {{ getTextByStatus(item.status) }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(eventItem, eventIndex) in item.items" :key="eventIndex">
                    <v-expansion-panel-header aria-label="Formulario com os dados do negócio">
                      <div>
                        <strong>Origem:</strong>
                        <span>
                          {{ truncateText(eventItem.origin || 'N/A', 30) }}
                        </span>
                        /
                        <strong>Valor:</strong>
                        <span v-if="eventItem.amount">
                          <!-- {{ eventItem.currency | enum(dataset.currencyTypes, "id", "currencyFormat") }} -->
                          <!-- {{ eventItem.amount | currency }} -->
                          {{ formatValue(eventItem.amount, eventItem.currency) }}
                        </span>
                        <span v-else>N/A</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <p tabindex="0">
                            <span class="section-info-title">Devedora</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              <!-- {{ item.client.name }} -->
                              {{ eventItem.company_name }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Origem</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ eventItem.origin }}</span>
                          </p>
                          <p v-if="eventItem.request_number" tabindex="0">
                            <span class="section-info-title">Nº de Identificação</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              eventItem.request_number
                              }}</span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Moeda</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ eventItem.currency | enum(dataset.currencyTypes, 'id', 'name') }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Valor</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ formatValue(eventItem.amount, eventItem.currency) }}
                            </span>
                          </p>
  
                          <p tabindex="0">
                            <span class="section-info-title">Observações</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              eventItem.observation
                              }}</span>
                          </p>
  
                          <p tabindex="0">
                            <span class="section-info-title">Análise da Administração Judicial</span>
                            <br />
                            <span class="section-info-value text-uppercase" v-html="getTruncatedReason(eventItem.reason)"></span>
                            <v-btn 
                              v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150" 
                              text 
                              small 
                              color="primary" 
                              @click="toggleReason" 
                              class="ml-2">
                              {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                            </v-btn>
                          </p>
  
                          <p tabindex="0">
                            <span class="section-info-title">Documento(s)</span>
                            <br />
                            <span class="section-info-value">{{ eventItem.docs.length }} arquivo(s)</span>
                          </p>
                          <v-row>
                            <v-col v-for="(itemDoc, docIndex) in eventItem.docs" :key="docIndex">
                              <v-card>
                                <v-img @click="openDoc(itemDoc.doc.file_url)" class="rounded-xl"
                                  lazy-src="https://picsum.photos/id/11/10/6" :height="70" :width="70"
                                  :src="itemDoc.doc.file_url"></v-img>
                                <v-card-text class="pa-0 file-text">
                                  {{ itemDoc.doc.name }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
  
                          <!-- <template>
                            <div v-if="dataset.data.release_status != 1">
                              <p class="mt-6">
                                <span class="section-info-title">Motivo</span>
                                <br />
                              </p>
                              <div v-html="completeReason ? item.reason : item.small_reason"></div>
                              <v-row>
                                <v-col>
                                  <v-btn color="primary" outlined @click.native="completeReason = !completeReason">
                                    {{
                                    completeReason ? 'Ocultar motivo completo' : 'Ver motivo completo'
                                    }}</v-btn>
                                </v-col>
                              </v-row>
                            </div>
  
                          </template> -->
  
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="item.items.length > 1">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </div>
        </template>
  
        <!-- <v-row no-gutters>
          <v-col>
            <br>
            <iframe width="600" height="500" src="https://www.youtube.com/embed/6okzXsdt0k0" frameborder="0"
              aria-hidden="true" arial-label="Video demonstrativo para criar uma habilitação ou divergência"
              allowfullscreen aria-label="Video de demonstração de como proceder" alt=""></iframe>
          </v-col>
        </v-row> -->
  
        <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
          <v-card>
            <v-img :src="selectedDoc" alt="" contain />
          </v-card>
        </v-dialog>
  
        <!-- Modal para exluir hab-div-->
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title class="blue--text text--darken-2"
              style="border-bottom: 4px solid #007bff; padding-bottom: 8px;">
              Excluir habilitação / divergência
            </v-card-title>
            <br>
            <v-card-text tabindex="0">
              Deseja <b>excluir</b> esta habilitação / divergência?<br><br>
              <span class="font-weight-bold">OBS.:</span> Esta operação é irreversível! Caso necessário, outra habilitação
              /
              divergência poderá ser criada.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" tabindex="0" text @click="dialog = false"
                aria-label="Botão para cancelar operação e não remover a habilitação ou divergência">Cancelar</v-btn>
              <v-btn color="red" tabindex="0" text @click="confirmDelete()"
                aria-label="Botão para confirmar a remoção da habilitação ou divergência">Excluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
        <!-- Modal para mostrar texto do motivo curto e motivo longo-->
        <v-dialog v-model="dialogReason" max-width="600">
          <v-card>
            <v-card-title class="blue--text text--darken-2"
              style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center;">
              Análise da Administração Judicial
            </v-card-title>
            <br>
            <v-card-text v-if="data && data.length > 0" tabindex="0">
              <p tabindex="0">
                <span class="section-info-title">Análise da Administração Judicial - resumida</span>
                <br />
                <!-- <span class="section-info-value text-uppercase" v-html="stripHtml(data[0].small_reason)"></span> -->
              </p>
              <div v-html="data[0].small_reason"></div>
            </v-card-text>
            <v-card-text v-if="data && data.length > 0" tabindex="0">
              <p tabindex="0">
                <span class="section-info-title">Análise da Administração Judicial - detalhada</span>
                <br />
                <!-- <span class="section-info-value text-uppercase" v-html="stripHtml(data[0].reason)"></span> -->
              </p>
              <div v-html="data[0].reason"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" tabindex="0" text @click="dialogReason = false"
                aria-label="Botão para fechar a janela com a descrição do motivo">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
        <!-- Modal para enviar os documentos solicitados-->
        <v-dialog v-model="dialogUpdateRequestedDocs" max-width="800px">
          <v-card>
            <v-card-title class="card-title">
              Atualização de documentos
            </v-card-title>
            <br>
  
            <v-card-text>
              <p>Para mais detalhes sobre a documentação ausente, entre em contato por telefone através dos números
                indicados neste site.</p>
              <p>Documentos relacionados com as empresas 123 VIAGENS E TURISMO LTDA., ART VIAGENS E TURISMO LTDA.
                (HotMilhas), NOVUM INVESTIMENTOS PARTICIPAÇÕES S.A., LH -
                LANCE HOTEIS LTDA. e MM TURISMO & VIAGENS S.A. (MaxMilhas). A empresa HOTEL URBANO não faz parte deste
                processo e todos os documentos relacionados ao HOTEL
                URBANO serão desconsiderados.</p>
            </v-card-text>
            <v-divider></v-divider>
  
            <v-progress-linear v-if="documentUploadLoading" indeterminate color="blue">
            </v-progress-linear>
  
            <v-card-text>
              <v-container v-if="mainDocs.length > 0">
                <v-row>
                  <v-col cols="12">
                    <h3>Documentos Principais</h3>
                    <v-list dense>
                      <v-list-item v-for="doc in mainDocs" :key="doc.id" class="align-start" style="margin-bottom: 20px;">
                        <v-row class="d-flex align-center justify-space-between">
                          <v-col cols="8" class="d-flex align-center">
                            <v-list-item-content class="doc-title">
                              <v-list-item-title>- {{ doc.name }}</v-list-item-title>
                            </v-list-item-content>
                          </v-col>
  
                          <div class="d-flex align-center">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="!doc.uploaded" :loading="isLoading(doc)" :disabled="isLoading(doc)"
                                  @click="doc.selectedFile ? uploadDocument(doc, 1) : openFileDialog(doc)" outlined
                                  color="primary" v-bind="attrs" v-on="on">
                                  {{ doc.selectedFile ? 'Enviar' : 'Atualizar' }}
                                </v-btn>
                              </template>
                              <span v-if="!doc.selectedFile">Selecionar documento para ser enviado</span>
                              <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                            </v-tooltip>
  
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-show="!doc.uploaded && doc.selectedFile && doc.uploadStatus !== 'error'"
                                  class="ml-2" color="red" @click="clearSelectedFile(doc)" v-bind="attrs" v-on="on">
                                  mdi-close
                                </v-icon>
                              </template>
                              <span>Limpar e selecionar outro documento</span>
                            </v-tooltip>
  
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-show="doc.uploadStatus === 'error'" color="red" class="ml-3"
                                  @click="retryUpload(doc)" v-bind="attrs" v-on="on">
                                  mdi-close-circle
                                </v-icon>
                              </template>
                              <span>Erro no envio, clique aqui para tentar novamente</span>
                            </v-tooltip>
                          </div>
  
                          <div v-if="doc.uploaded || doc.uploadStatus === 'success'" class="d-flex align-center">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-show="!doc.selectedFile" color="green" class="ml-3" v-bind="attrs" v-on="on">
                                  mdi-check-circle
                                </v-icon>
                              </template>
                              <span>Documento enviado</span>
                            </v-tooltip>
  
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined small color="primary" class="ml-2" :loading="isLoading(doc)"
                                  :disabled="isLoading(doc)"
                                  @click="doc.selectedFile ? uploadDocument(doc, 1) : openFileDialog(doc)" v-bind="attrs"
                                  v-on="on">
                                  <template v-slot:default>
                                    <span v-if="!(activeDocumentId === doc.id && documentUploadLoading)">
                                      {{ doc.selectedFile ? 'Enviar' : 'Alterar' }}
                                    </span>
                                  </template>
                                  <template v-slot:loader>
                                    <v-progress-circular indeterminate color="primary" size="25" width="3" />
                                  </template>
                                </v-btn>
                              </template>
                              <template v-slot:default>
                                <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                                <span v-if="!doc.selectedFile">Substituir documento enviado anteriormente</span>
                              </template>
                            </v-tooltip>
                          </div>
  
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-container>
  
              <v-divider v-if="mainDocs.length > 0"></v-divider>
  
              <v-container v-if="businessDocs.length > 0">
                <v-row>
                  <v-col cols="12">
                    <h3>Documentos Comprobatórios</h3>
                    <br>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(businessDoc, index) in businessDocs"
                        :key="businessDoc.origin + '-' + index">
                        <v-expansion-panel-header>
                          <div class="d-flex align-center">
                            <strong>Origem: </strong>
                            <span class="ml-2 mr-2">
                              {{ businessDoc.origin }}
                            </span>
                            /
                            <strong class="ml-2">Valor: </strong>
                            <span class="ml-2">
                              {{ businessDoc.amount }}
                            </span>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item v-for="(doc, docIndex) in businessDoc.docs" :key="doc.id + '-' + docIndex"
                              class="compact-item">
  
                              <v-list-item-content>
                                <v-list-item-title class="doc-title">
                                  - {{ doc.name }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
  
                                <div class="d-flex align-center">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-if="!doc.uploaded" :loading="isLoading(doc)" :disabled="isLoading(doc)"
                                        @click="doc.selectedFile ? uploadDocument(doc, 2) : openFileDialog(doc)" outlined
                                        color="primary" v-bind="attrs" v-on="on">
                                        {{ doc.selectedFile ? 'Enviar' : 'Atualizar' }}
  
                                      </v-btn>
                                    </template>
                                    <span v-if="!doc.selectedFile">Selecionar documento para ser enviado</span>
                                    <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                                  </v-tooltip>
  
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-show="!doc.uploaded && doc.selectedFile && doc.uploadStatus !== 'error'"
                                        class="ml-2" color="red" @click="clearSelectedFile(doc)" v-bind="attrs" v-on="on">
                                        mdi-close
                                      </v-icon>
                                    </template>
                                    <span>Limpar e selecionar outro documento</span>
                                  </v-tooltip>
  
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-show="doc.uploadStatus === 'error'" color="red" class="ml-3"
                                        @click="retryUpload(doc)" v-bind="attrs" v-on="on">
                                        mdi-close-circle
                                      </v-icon>
                                    </template>
                                    <span>Erro no envio! Clique aqui para tentar novamente</span>
                                  </v-tooltip>
                                </div>
  
                                <div v-if="doc.uploaded || doc.uploadStatus === 'success'" class="d-flex align-center">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-show="!doc.selectedFile" color="green" class="ml-3" v-bind="attrs"
                                        v-on="on">
                                        mdi-check-circle
                                      </v-icon>
                                    </template>
                                    <span>Documento enviado</span>
                                  </v-tooltip>
  
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn outlined small color="primary" class="ml-2" :loading="isLoading(doc)"
                                        :disabled="isLoading(doc)"
                                        @click="doc.selectedFile ? uploadDocument(doc, 2) : openFileDialog(doc)"
                                        v-bind="attrs" v-on="on">
                                        <span v-if="!isLoading(doc)">
                                          {{ doc.selectedFile ? 'Enviar' : 'Alterar' }}
                                        </span>
                                        <template v-slot:loader>
                                          <v-progress-circular indeterminate color="primary" size="25" width="3" />
                                        </template>
                                      </v-btn>
                                    </template>
                                    <template v-slot:default>
                                      <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                                      <span v-if="!doc.selectedFile">Substituir documento enviado anteriormente</span>
                                    </template>
                                  </v-tooltip>
                                </div>
  
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="dialogUpdateRequestedDocs = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
          <input type="file" ref="fileInput" @change="handleFileChange" style="display: none"
            :key="selectedDocument && selectedDocument.selectedFile ? selectedDocument.selectedFile.name : 'new-file'" />
        </v-dialog>
      </div>
    </v-container>
  </template>
  
  <script>
  import 'moment/locale/pt-br'
  import { eventHub } from '@/main'
  import currencyTypes from '@/common/data/currency-types.data'
  import creditorDocTypes from '@/common/data/creditor-email-doc-types.data'
  import businessDocTypes from '@/common/data/business-doc-types.data'
  import axios from 'axios'
  
  import moment from 'moment-timezone'
  
  export default {
    data: () => ({
      user: null,
      data: [],
      loading: false,
      dialog: false,
      dialogReason: false,
      isReasonExpanded: false,
      selectedItem: null,
      creditorDocTypes: creditorDocTypes,
      businessDocTypes: businessDocTypes,
      requestedDocDeadline: null,
      requestedDocOutOfDate: false,
      dataset: {
        contentUserAnonymous: '',
        contentUserLogged: '',
        currencyTypes: currencyTypes,
        isAssociationCreditor: false,
        userRequestedValue: 0,
        loading: false,
        clients: [],
        data: {
          items: [],
          client: null,
          release_status: null,
        }
      },
      document: {
        files: []
      },
      selectedDocument: null,
      completeReason: false,
      selectedDoc: null,
      dialogViewDoc: false,
      dialogUpdateRequestedDocs: false,
      showModal: false,
      businessDocs: [],
      mainDocs: [],
      processedDocuments: [],
      processes: [],
      isTimely: false,
      showLateWarning: false,
  
      loadingStatus: false,
      documentUploadLoading: false,
      activeDocumentId: null,
      isLoaded: false,
    }),
  
    created() {
      this.$ga.event({
        eventCategory: 'page',
        eventAction: 'action',
        eventLabel: 'click',
        eventValue: 'user-area'
      })
  
      this.loadData()
      this.loadUserInfo();
    },
  
    methods: {
      async loadData() {
        this.dataset.loading = true
        this.loadingStatus = true
  
        try {
          await this.loadText()
          // await this.loadClients();
  
          if (this.$root.user) {
            await this.verifyAssociation()
            //await this.loadUserInfo()
            await this.load()
            await this.fetchReleaseStatus()
  
          }
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
          })
        } finally {
          this.dataset.loading = false
        }
      },
  
      clearSelectedFile(doc) {
        doc.selectedFile = null;
      },
  
      retryUpload(doc) {
        doc.uploadProgress = 0;
        doc.uploadStatus = "uploading";
        doc.selectedFile = null;
        this.openFileDialog(doc);
      },
  
      isLoading(doc) {
        return this.activeDocumentId === doc.id && this.documentUploadLoading;
      },
  
      openFileDialog(doc) {
  
        const mainDocs = this.mainDocs || [];
        const businessDocs = this.businessDocs || [];
        const allDocs = [
          ...mainDocs,
          ...businessDocs.flatMap((item) => item.docs || []),
        ];
  
        const pendingUpload = allDocs.find((d) => d.selectedFile && !d.uploaded);
  
        if (pendingUpload) {
          this.$dialog.notify.error(
            `Você tem o documento "${pendingUpload.name}" pendente! Por favor, envie-o antes de selecionar outro.`,
            {
              position: "top-right",
              timeout: 5000,
            }
          );
          return;
        }
  
        this.selectedDocument = doc;
        this.$refs.fileInput.click();
      },
  
      handleFileChange(event) {
        const file = event.target.files[0];
  
        if (!this.selectedDocument || typeof this.selectedDocument !== "object") {
          this.$dialog.notify.error("Documento selecionado não é válido!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        if (file) {
          this.$set(this.selectedDocument, "selectedFile", file);
        }
      },
  
      async uploadDocument(doc, type) {
        if (!doc.selectedFile) {
          this.$dialog.notify.error("Erro ao enviar o documento selecionado!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        const formData = new FormData();
        formData.append("file", doc.selectedFile);
        formData.append("type", type);
        formData.append("ref", doc.id);
  
        if (doc.item_id) formData.append("item_id", doc.item_id);
  
        const targetList = type === 1 ? this.mainDocs : this.businessDocs;
        const targetDoc = this.findDocumentInList(targetList, doc.id, type);
  
        if (!targetDoc) {
          this.$dialog.notify.error("Documento não encontrado!", {
            position: "top-right",
            timeout: 5000,
          });
          return;
        }
  
        try {
  
          this.activeDocumentId = doc.id
          this.documentUploadLoading = true;
  
          const response = await axios.patch(
            `/api/user-events/update-item-doc/${doc.event_id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
  
            }
          );
  
          if (response.status === 200) {
            const docIndex = type === 1
              ? this.mainDocs.findIndex((d) => d.id === doc.id)
              : this.businessDocs.findIndex((businessDoc) =>
                  businessDoc.item_id === doc.item_id &&
                  businessDoc.docs.some((d) => d.id === doc.id)
                );
  
            if (type === 1 && docIndex !== -1) {
              this.$set(this.mainDocs, docIndex, {
                ...this.mainDocs[docIndex],
                uploadStatus: "success",
                uploaded: true,
                selectedFile: null,
              });
            } else if (type !== 1 && docIndex !== -1) {
              const businessDoc = this.businessDocs[docIndex];
              const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);
  
              if (innerDocIndex !== -1) {
                this.$set(businessDoc.docs, innerDocIndex, {
                  ...businessDoc.docs[innerDocIndex],
                  uploadStatus: "success",
                  uploaded: true,
                  selectedFile: null,
                });
              }
            }
            this.businessDocs.forEach((businessDoc) => {
              businessDoc.docs.forEach((doc) => {
                if (doc.selectedFile !== null) {
                  doc.selectedFile = null; 
                }
              });
            });
  
            this.$dialog.notify.success("Arquivo enviado com sucesso!", {
              position: "top-right",
              timeout: 5000,
            });
          } else {
            throw new Error("Erro não identificado!");
          }
        } catch (error) {
  
          const docIndex = type === 1
            ? this.mainDocs.findIndex((d) => d.id === doc.id)
            : this.businessDocs.findIndex((businessDoc) =>
              businessDoc.docs.some((d) => d.id === doc.id)
            );
  
          if (type === 1 && docIndex !== -1) {
            this.$set(this.mainDocs, docIndex, {
              ...this.mainDocs[docIndex],
              uploadStatus: "error",
              uploaded: false,
            });
          } else if (type !== 1 && docIndex !== -1) {
            const businessDoc = this.businessDocs[docIndex];
            const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);
  
            if (innerDocIndex !== -1) {
              this.$set(businessDoc.docs, innerDocIndex, {
                ...businessDoc.docs[innerDocIndex],
                uploadStatus: "error",
                uploaded: false,
              });
            }
          }
  
          this.$dialog.notify.error("Erro ao enviar o documento!", {
            position: "top-right",
            timeout: 5000,
          });
        }
  
        this.documentUploadLoading = false;
        this.activeDocumentId = null;
      },
  
      findDocumentInList(list, docId, type) {
        if (type === 1) {
          return list.find((doc) => doc.id === docId);
        } else {
          for (const businessDoc of list) {
            const foundDoc = businessDoc.docs.find((d) => d.id === docId);
            if (foundDoc) {
              return foundDoc;
            }
          }
        }
        return null;
      },
  
  
      loadRequestedDocuments() {
  
        if (this.isLoaded) {
          this.dialogUpdateRequestedDocs = true;
          return;
        }
  
        let requestedDocs = [];
  
        try {
          if (this.data[0] && this.data[0].requested_doc) {
            requestedDocs = JSON.parse(this.data[0].requested_doc);
          }
        } catch (error) {
          this.$dialog.notify.error("Erro ao buscar a lista de documentos!", { position: 'top-right', timeout: 5000 });
          return;
        }
  
        const currencyType = this.data && this.data.items && this.data.items[0] && this.data.items[0].currency
          ? this.data.items[0].currency
          : 1;
        const currencySymbol = this.dataset && this.dataset.currencyTypes
          ? this.dataset.currencyTypes.find(type => type.id === currencyType).symbol || 'R$'
          : 'R$';
  
        if (Array.isArray(requestedDocs) && requestedDocs.length > 0) {
          const mainDocs = [];
          const businessDocsGrouped = [];
  
          requestedDocs.forEach((docGroup) => {
            if (docGroup.user_event_id) {
              // Documentos principais
              const mainDocumentNames = docGroup.docs.map((doc) => {
                const foundDoc = this.creditorDocTypes.find((ref) => ref.id === doc.id);
                return foundDoc
                  ? {
                    ...foundDoc,
                    uploaded: doc.uploaded || false,
                    event_id: docGroup.user_event_id,
                    selectedFile: null,
                  }
                  : null;
              }).filter(doc => doc !== null && doc.id !== 3);
  
              mainDocs.push(...mainDocumentNames);
            } else {
              // Documentos de negócios
              const existingBusiness = businessDocsGrouped.find(
                (business) => business.item_id === docGroup.user_event_item_id
              );
  
              if (existingBusiness) {
                docGroup.docs.forEach((doc) => {
                  const businessDoc = this.businessDocTypes.find((ref) => ref.id === doc.id);
                  if (businessDoc) {
                    existingBusiness.docs.push({
                      ...businessDoc,
                      name: doc.id === 50 && doc.customName ? doc.customName : businessDoc.name,
                      uploaded: doc.uploaded || false,
                      event_id: this.data[0].id,
                      item_id: docGroup.user_event_item_id,
                      selectedFile: null,
                    });
                  }
                });
  
              } else {
                const newBusinessDocs = docGroup.docs.map((doc) => {
                  const businessDoc = this.businessDocTypes.find((ref) => ref.id === doc.id);
                  return businessDoc
                    ? {
                      ...businessDoc,
                      name: doc.id === 50 && doc.customName ? doc.customName : businessDoc.name,
                      uploaded: doc.uploaded || false,
                      item_id: docGroup.user_event_item_id,
                      event_id: this.data[0].id,
                      uploadProgress: 0,
                      selectedFile: null,
                    }
                    : null;
                }).filter((doc) => doc !== null);
  
                const formattedAmount = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: this.getCurrencyCode(currencyType),
                }).format(docGroup.amount || 0);
  
                businessDocsGrouped.push({
                  item_id: docGroup.user_event_item_id,
                  event_id: this.data[0].id,
                  origin: docGroup.origin,
                  amount: formattedAmount,
                  docs: newBusinessDocs,
                });
              }
            }
          });
  
          this.isLoaded = true;
          this.mainDocs = mainDocs;
          this.businessDocs = businessDocsGrouped;
          this.dialogUpdateRequestedDocs = true;
  
        }
      },
  
      getCurrencyCode(currencyType) {
        switch (currencyType) {
          case 1:
            return 'BRL';
          case 2:
            return 'USD';
          case 3:
            return 'EUR';
          default:
            return 'BRL';
        }
      },
  
      formatValue(value, currency) {
        if (value === null || value === undefined) {
          return 'N/A'
        }
  
        let options = {
          style: 'currency',
          currency: 'BRL'
        }
  
        switch (currency) {
          case 1:
            options.currency = 'BRL'
            break
          case 2:
            options.currency = 'USD'
            break
          case 3:
            options.currency = 'EUR'
            break
          default:
            options.currency = 'BRL'
        }
  
        return new Intl.NumberFormat('pt-BR', options).format(value)
      },
  
      truncateText(text, maxLength) {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
      },
  
      openDoc(doc) {
        window.open(doc, '_blank')
      },
  
      verifyCondition() {
        return this.data.some(item => item.client && item.client.event_report_file);
      },
  
      async fetchReleaseStatus() {
        this.loadingStatus = true;
  
        try {
          const result = await axios.get(`/api/clients/1`);
  
          const data = result.data.content;
  
          this.dataset.data = {
            ...data,
            release_status: data.release_status,
          };
  
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000
          })
        } finally {
          this.loadingStatus = false;
        }
      },
  
      async verifyAssociation() {
        const result = await axios.get('/api/user-creditors/association')
  
        const data = result.data.content
  
        // if (!data) return;
  
        if (!data || data.length === 0) return
  
        this.dataset.isAssociationCreditor = true
        this.dataset.userRequestedValue = data[0].amount
      },
  
      async loadText() {
        const result = await axios.get(`/api/dynamic-infos/keys`, {
          params: { keys: 'user-event-anonymous,user-event-logged' }
        })
  
        if (!result.data.content) return
  
        let contentUserAnonymous = result.data.content.find(x => x.key === 'user-event-anonymous')
        let contentUserLogged = result.data.content.find(x => x.key === 'user-event-logged')
  
        this.dataset.contentUserAnonymous = contentUserAnonymous ? contentUserAnonymous.value : ''
        this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : ''
      },
  
      async loadUserInfo() {
        try {
          const result = await axios.get('/api/users/info')
  
          this.user = result.data.content
  
          this.isTimely =
            this.user.timely_date && this.user.timely_date !== '0000-00-00 00:00:00';
  
          const eventResponse = await axios.get(`/api/user-events/request`);
          const events = eventResponse.data.content;
  
          this.showLateWarning = events.some(event => {
            const eventDate = new Date(event.created_at);
            return eventDate >= new Date('2024-12-04T00:00:00');
          });
  
        } catch (error) {
          console.error('Erro ao carregar informações do usuário:', error);
          this.$dialog.notify.error(this.$codes(error), {
            position: 'top-right',
            timeout: 2000,
          });
        }
      },
  
      async load() {
        const result = await axios.get('/api/user-events/request')
  
        this.data = result.data.content
  
        console.log("Data: ", this.data)
  
        this.processes = [];
  
        this.data.forEach(item => {
          if (Array.isArray(item.processes) && item.processes.length > 0) {
            this.processes = [...this.processes, ...item.processes]
          }
        })
  
        const reqData = this.data[0];
  
        if (reqData) {
  
          const requestedDocAt = reqData.requested_doc_at
            ? moment(reqData.requested_doc_at).utc()
            : null;
  
          if (requestedDocAt) {
            const deadlineDate = moment(requestedDocAt).add(72, 'hours').utc();
            const now = moment().utc();
  
            const dayOfWeek = deadlineDate.isoWeekday();
            if (dayOfWeek === 6) {
              deadlineDate.add(2, "days");
            } else if (dayOfWeek === 7) {
              deadlineDate.add(1, "day");
            }
  
            this.requestedDocOutOfDate = now.isAfter(deadlineDate);
  
            const hoursDifference = deadlineDate.diff(now, 'hours');
            //console.log(`Diferença em horas: ${hoursDifference}`);
            //console.log("Fora do prazo: ", this.requestedDocOutOfDate);
  
            const formattedDate = deadlineDate.tz('America/Sao_Paulo').format('DD/MM/YYYY [às] HH:mm');
  
            console.log('formattedDate ', formattedDate)
  
            this.requestedDocDeadline = `dia ${formattedDate}`;
          }
        }
      },
  
      getColorByStatus(status) {
        switch (status) {
          case 0:
            return 'warning'
          case 1:
            return 'accent'
          case 2:
            return 'important'
          case 3:
            return 'primary'
  
          default:
            break
        }
      },
  
      getTextByStatus(status) {
        switch (status) {
          case 0:
            return 'Aguardando análise'
          case 1:
            return 'Aprovado'
          case 2:
            return 'Rejeitado'
          case 3:
            return 'Aprovado parcial'
  
          default:
            break
        }
      },
  
      editItem(item) {
        this.$router.push(`habilitacoes-divergencias/${item.id}`)
        window.scrollTo(0, 0)
      },
  
      openDeleteDialog(item) {
        this.selectedItem = item;
        this.dialog = true;
      },
  
      async confirmDelete() {
        this.dialog = false;
        if (this.selectedItem) {
          await this.deleteItem(this.selectedItem);
        }
      },
  
      async deleteItem(item) {
  
        this.dataset.loading = true;
  
        try {
          const response = await axios.delete(`/api/user-events/request/delete/${item.id}`)
  
          this.$dialog.notify.success("Habilitação / divergência excluída com sucesso!", { position: 'top-right', timeout: 5000 });
  
          this.load()
  
        } catch (error) {
          if (error.response && error.response.status === 400) {
            this.$dialog.notify.error(error.response.data.message, { position: 'top-right', timeout: 5000 });
          } else {
            this.$dialog.notify.error("Erro ao excluir a habilitação / divergência!", { position: 'top-right', timeout: 5000 });
          }
        } finally {
          this.dataset.loading = false;
  
          this.selectedItem = null;
        }
  
      },
  
      async onDisagree() {
  
        const proceedAction = await this.$dialog.confirm({
          text: 'Deseja revogar a concordância do valor efetuada anteriormente?',
          title: 'Revogar concordância',
          actions: {
            false: 'Cancelar',
            true: 'revogar'
          }
        });
  
        if (!proceedAction) return;
  
        this.dataset.loading = true;
  
        try {
          const response = await axios.post('/api/user-creditors/restore-approved-amount')
  
          this.$dialog.notify.success("Concordância de crédito revogada com sucesso!", { position: 'top-right', timeout: 5000 });
  
          this.loadData()
  
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        } finally {
          this.dataset.loading = false;
        }
  
      },
  
      viewCreateEvent() {
        this.$router.push(`habilitacoes-divergencias/novo`)
      },
  
      viewReason() {
  
        this.dialogReason = true;
      
      },
  
      stripHtml(html) {
        if (!html) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
      },
  
      getTruncatedReason(reason) {
        const rawText = this.stripHtml(reason);
        if (!this.isReasonExpanded && rawText.length > 150) {
          return rawText.substring(0, 150) + '...';
        }
        return rawText;
      },
  
      toggleReason() {
        this.isReasonExpanded = !this.isReasonExpanded;
      }
  
     
    }
  }
  </script>
  
  <style lang="scss">
  .title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
  }
  
  .section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
  
  .section-info-value {
    font-family: 'Raleway';
    font-size: 14px;
    font-style: normal;
  }
  
  .custom-panel-header {
    min-height: 20px !important;
    line-height: 20px !important;
    padding-top: 5 !important;
    padding-bottom: 0 !important;
  }
  
  .card-title {
    border-bottom: 4px solid #2373c9 !important;
    padding-bottom: 8px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    // font-family: 'Raleway' !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    text-align: center !important;
  }
  
  .button-with-border {
    background-color: #ffffff;
    border: 2px solid #FF6F00;
    padding: 10px 20px;
    border-radius: 5px;
  }
  
  .button-with-border:hover {
    background-color: #f7994d;
    color: rgb(247, 243, 243) !important;
  }
  
  .compact-item {
    margin: 0;
    padding: 0;
  }
  
  .compact-item p {
    margin: 4px 0;
    font-size: 14px;
  }
  
  .doc-title {
    white-space: normal;
    word-wrap: break-word;
    max-width: calc(100% - 120px);
    margin-right: 16px;
  }
  
  .compact-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  </style>
  